import "./app.d95afe78.js";


function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire8ebf"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire8ebf"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;

var $jLyQP = parcelRequire("jLyQP");

var $2qSCu = parcelRequire("2qSCu");

var $jLyQP = parcelRequire("jLyQP");

var $gELpr = parcelRequire("gELpr");

var $jLyQP = parcelRequire("jLyQP");

var $gELpr = parcelRequire("gELpr");
const $6b8304e8db19bdb3$export$7037112d28c7d171 = (0, window.location.origin);
const $6b8304e8db19bdb3$var$initialState = {
    jwksUrl: "",
    jwks: "",
    jwksError: "",
    err: "",
    dur: 0,
    loading: false,
    error: null,
    assertion: "",
    matchServer: "",
    keyType: "url",
    sampleAlg: "ES384",
    fakeMatches: 0,
    duplicates: 0,
    mode: "normal",
    proxyClientId: "",
    proxyJWK: "",
    proxyScope: ""
};
function $6b8304e8db19bdb3$var$reducer(state, action) {
    const { type: type, payload: payload } = action;
    switch(type){
        case "setJwksUrl":
            return {
                ...state,
                jwksUrl: payload
            };
        case "setErr":
            return {
                ...state,
                err: payload
            };
        case "setDur":
            return {
                ...state,
                dur: payload
            };
        case "setLoading":
            return {
                ...state,
                loading: payload
            };
        case "setAssertion":
            return {
                ...state,
                assertion: payload
            };
        case "setMatchServer":
            return {
                ...state,
                matchServer: payload
            };
        case "setKeyType":
            return {
                ...state,
                keyType: payload
            };
        case "setSampleAlg":
            return {
                ...state,
                sampleAlg: payload
            };
        case "setFakeMatches":
            return {
                ...state,
                fakeMatches: payload
            };
        case "setDuplicates":
            return {
                ...state,
                duplicates: payload
            };
        case "setMode":
            return {
                ...state,
                mode: payload
            };
        case "setProxyClientId":
            return {
                ...state,
                proxyClientId: payload
            };
        case "setProxyJWK":
            return {
                ...state,
                proxyJWK: payload
            };
        case "setProxyScope":
            return {
                ...state,
                proxyScope: payload
            };
        case "setJwks":
            {
                const out = {
                    ...state,
                    jwks: payload,
                    jwksError: ""
                };
                try {
                    const json = JSON.parse(payload);
                    if (!json || typeof json !== "object") out.jwksError = "Not a JSON object";
                } catch  {
                    out.jwksError = "Not a valid JSON";
                }
                return out;
            }
        case "merge":
            return {
                ...state,
                ...payload
            };
    }
    return state;
}
function $6b8304e8db19bdb3$export$2e2bcd8739ae039() {
    const [state, dispatch] = (0, $gELpr.useReducer)($6b8304e8db19bdb3$var$reducer, $6b8304e8db19bdb3$var$initialState);
    const { jwksUrl: jwksUrl, jwks: jwks, jwksError: jwksError, err: err, dur: dur, loading: loading, error: error, assertion: assertion, matchServer: matchServer, keyType: keyType, sampleAlg: sampleAlg, fakeMatches: fakeMatches, duplicates: duplicates, mode: mode, proxyClientId: proxyClientId, proxyJWK: proxyJWK, proxyScope: proxyScope } = state;
    const [headers, setHeaders] = (0, $gELpr.useState)([]);
    const cannotSubmit = !!(loading || keyType === "url" && !jwksUrl || keyType === "inline" && (!jwks || jwksError) || mode === "fake" && !fakeMatches);
    function onSubmit(e) {
        e.preventDefault();
        dispatch({
            type: "merge",
            payload: {
                loading: true,
                err: ""
            }
        });
        let body = new URLSearchParams({
            err: err,
            accessTokensExpireIn: dur + ""
        });
        if (keyType === "url") body.set("jwks_url", jwksUrl);
        else if (keyType === "inline") body.set("jwks", JSON.stringify({
            keys: [
                JSON.parse(jwks)
            ]
        }));
        else if (keyType === "sample") body.set("jwks_url", `${$6b8304e8db19bdb3$export$7037112d28c7d171}/keys/${sampleAlg}.jwks.json`);
        if (mode === "fake") {
            body.set("fakeMatches", fakeMatches + "");
            body.set("duplicates", duplicates + "");
        } else if (mode === "remote") {
            body.set("matchServer", matchServer);
            body.set("proxyClientId", proxyClientId);
            body.set("proxyJWK", proxyJWK);
            body.set("proxyScope", proxyScope);
        }
        fetch("/auth/register", {
            method: "POST",
            headers: {
                "content-type": "application/x-www-form-urlencoded"
            },
            body: body
        }).then((res)=>{
            return res.text().then((txt)=>{
                if (!res.ok) throw txt;
                return txt;
            });
        }).then((result)=>dispatch({
                type: "setAssertion",
                payload: result
            })).catch((e)=>dispatch({
                type: "setError",
                payload: e
            })).finally(()=>dispatch({
                type: "setLoading",
                payload: false
            }));
    }
    return /*#__PURE__*/ (0, $jLyQP.jsxs)("form", {
        onSubmit: onSubmit,
        className: "mb-5",
        children: [
            error && /*#__PURE__*/ (0, $jLyQP.jsx)("div", {
                className: "alert alert-danger",
                children: error + ""
            }),
            /*#__PURE__*/ (0, $jLyQP.jsxs)("h5", {
                className: "text-primary",
                children: [
                    /*#__PURE__*/ (0, $jLyQP.jsx)("i", {
                        className: "bi bi-shield-lock"
                    }),
                    " Public Key"
                ]
            }),
            /*#__PURE__*/ (0, $jLyQP.jsx)("div", {
                className: "my-2 bg-primary-subtle",
                style: {
                    height: 2
                }
            }),
            /*#__PURE__*/ (0, $jLyQP.jsxs)("div", {
                className: "row mt-3",
                children: [
                    /*#__PURE__*/ (0, $jLyQP.jsxs)("div", {
                        className: "col-lg-6 mb-5",
                        children: [
                            /*#__PURE__*/ (0, $jLyQP.jsx)("div", {
                                className: "form-check mb-3",
                                children: /*#__PURE__*/ (0, $jLyQP.jsxs)("label", {
                                    className: "form-check-label",
                                    children: [
                                        /*#__PURE__*/ (0, $jLyQP.jsx)("input", {
                                            className: "form-check-input",
                                            type: "radio",
                                            name: "keyType",
                                            checked: keyType === "url",
                                            onChange: ()=>dispatch({
                                                    type: "setKeyType",
                                                    payload: "url"
                                                })
                                        }),
                                        "Fetch the key from JWKS URL (",
                                        /*#__PURE__*/ (0, $jLyQP.jsx)("b", {
                                            children: "recommended"
                                        }),
                                        ")",
                                        /*#__PURE__*/ (0, $jLyQP.jsx)("div", {
                                            className: "form-text mt-0",
                                            children: "Provide an URL to your JWKS containing your public key(s)"
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0, $jLyQP.jsx)("div", {
                                className: "form-check mb-3",
                                children: /*#__PURE__*/ (0, $jLyQP.jsxs)("label", {
                                    className: "form-check-label",
                                    children: [
                                        /*#__PURE__*/ (0, $jLyQP.jsx)("input", {
                                            className: "form-check-input",
                                            type: "radio",
                                            name: "keyType",
                                            checked: keyType === "inline",
                                            onChange: ()=>dispatch({
                                                    type: "setKeyType",
                                                    payload: "inline"
                                                })
                                        }),
                                        "Provide the key now",
                                        /*#__PURE__*/ (0, $jLyQP.jsx)("div", {
                                            className: "form-text mt-0",
                                            children: "Register your public key as JWK"
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0, $jLyQP.jsx)("div", {
                                className: "form-check mb-3",
                                children: /*#__PURE__*/ (0, $jLyQP.jsxs)("label", {
                                    className: "form-check-label",
                                    children: [
                                        /*#__PURE__*/ (0, $jLyQP.jsx)("input", {
                                            className: "form-check-input",
                                            type: "radio",
                                            name: "keyType",
                                            checked: keyType === "sample",
                                            onChange: ()=>dispatch({
                                                    type: "setKeyType",
                                                    payload: "sample"
                                                })
                                        }),
                                        "Use our example keys",
                                        /*#__PURE__*/ (0, $jLyQP.jsxs)("div", {
                                            className: "form-text mt-0",
                                            children: [
                                                "Use our sample pair of keys (",
                                                /*#__PURE__*/ (0, $jLyQP.jsx)("span", {
                                                    className: "text-danger",
                                                    children: "for testing only"
                                                }),
                                                ")"
                                            ]
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0, $jLyQP.jsx)("div", {
                                className: "form-check",
                                children: /*#__PURE__*/ (0, $jLyQP.jsxs)("label", {
                                    className: "form-check-label",
                                    children: [
                                        /*#__PURE__*/ (0, $jLyQP.jsx)("input", {
                                            className: "form-check-input",
                                            type: "radio",
                                            name: "keyType",
                                            checked: keyType === "none",
                                            onChange: ()=>{
                                                dispatch({
                                                    type: "setKeyType",
                                                    payload: "none"
                                                });
                                                if (mode === "remote") dispatch({
                                                    type: "merge",
                                                    payload: {
                                                        mode: "normal",
                                                        fakeMatches: 0,
                                                        duplicates: 0
                                                    }
                                                });
                                            }
                                        }),
                                        "None",
                                        /*#__PURE__*/ (0, $jLyQP.jsx)("div", {
                                            className: "form-text mt-0",
                                            children: "Use the server without authentication"
                                        })
                                    ]
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $jLyQP.jsxs)("div", {
                        className: "col-lg-6 mb-5",
                        children: [
                            keyType === "url" && /*#__PURE__*/ (0, $jLyQP.jsxs)((0, $jLyQP.Fragment), {
                                children: [
                                    /*#__PURE__*/ (0, $jLyQP.jsx)("label", {
                                        htmlFor: "jwks-url",
                                        className: "form-label text-primary-emphasis",
                                        children: "JWKS URL"
                                    }),
                                    /*#__PURE__*/ (0, $jLyQP.jsx)("input", {
                                        type: "url",
                                        className: "form-control",
                                        id: "jwks-url",
                                        value: jwksUrl,
                                        onChange: (e)=>dispatch({
                                                type: "setJwksUrl",
                                                payload: e.target.value
                                            }),
                                        placeholder: "https://yourdomain.com/your-public-jwks.json"
                                    }),
                                    /*#__PURE__*/ (0, $jLyQP.jsx)("div", {
                                        className: "form-text small",
                                        children: "This URL communicates the TLS-protected endpoint where the client's public JWK Set can be found. This endpoint SHALL be accessible without client authentication or authorization. Allows a client to rotate its own keys by updating the hosted content at the JWK Set URL and avoids the need for the FHIR authorization server to maintain and protect the JWK Set."
                                    })
                                ]
                            }),
                            keyType === "inline" && /*#__PURE__*/ (0, $jLyQP.jsxs)((0, $jLyQP.Fragment), {
                                children: [
                                    /*#__PURE__*/ (0, $jLyQP.jsxs)("div", {
                                        className: "d-flex justify-content-between",
                                        children: [
                                            /*#__PURE__*/ (0, $jLyQP.jsx)("label", {
                                                className: "form-label text-primary-emphasis",
                                                children: "Public Key JWK"
                                            }),
                                            /*#__PURE__*/ (0, $jLyQP.jsx)("div", {
                                                className: "form-label text-danger",
                                                children: /*#__PURE__*/ (0, $jLyQP.jsx)("small", {
                                                    children: jwks ? jwksError : ""
                                                })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $jLyQP.jsx)("textarea", {
                                        className: "form-control form-control-sm font-monospace",
                                        rows: 13,
                                        placeholder: "{ Public Key as JWK }",
                                        style: {
                                            whiteSpace: "pre",
                                            lineHeight: 1.2,
                                            fontSize: "13px"
                                        },
                                        value: jwks,
                                        onChange: (e)=>dispatch({
                                                type: "setJwks",
                                                payload: e.target.value
                                            })
                                    })
                                ]
                            }),
                            keyType === "sample" && /*#__PURE__*/ (0, $jLyQP.jsxs)((0, $jLyQP.Fragment), {
                                children: [
                                    /*#__PURE__*/ (0, $jLyQP.jsxs)("div", {
                                        className: "input-group",
                                        children: [
                                            /*#__PURE__*/ (0, $jLyQP.jsx)("span", {
                                                className: "input-group-text",
                                                children: "Key Type:"
                                            }),
                                            /*#__PURE__*/ (0, $jLyQP.jsxs)("select", {
                                                className: "form-select",
                                                value: sampleAlg,
                                                onChange: (e)=>dispatch({
                                                        type: "setSampleAlg",
                                                        payload: e.target.value
                                                    }),
                                                children: [
                                                    /*#__PURE__*/ (0, $jLyQP.jsx)("option", {
                                                        value: "ES384",
                                                        children: "ES384"
                                                    }),
                                                    /*#__PURE__*/ (0, $jLyQP.jsx)("option", {
                                                        value: "RS384",
                                                        children: "RS384"
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $jLyQP.jsxs)("div", {
                                        className: "form-text mt-3",
                                        children: [
                                            /*#__PURE__*/ (0, $jLyQP.jsx)("i", {
                                                className: "bi bi-info-circle-fill text-primary me-2"
                                            }),
                                            "The server will verify your token signature using the public key found at:",
                                            /*#__PURE__*/ (0, $jLyQP.jsx)("ul", {
                                                children: /*#__PURE__*/ (0, $jLyQP.jsx)("li", {
                                                    children: /*#__PURE__*/ (0, $jLyQP.jsxs)("a", {
                                                        href: `${$6b8304e8db19bdb3$export$7037112d28c7d171}/keys/${sampleAlg}.jwks.json`,
                                                        target: "_blank",
                                                        rel: "noreferrer",
                                                        children: [
                                                            $6b8304e8db19bdb3$export$7037112d28c7d171,
                                                            "/keys/",
                                                            sampleAlg,
                                                            ".jwks.json"
                                                        ]
                                                    })
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $jLyQP.jsx)("i", {
                                                className: "bi bi-info-circle-fill text-primary me-2"
                                            }),
                                            "A client must sign tokens with the private key found at:",
                                            /*#__PURE__*/ (0, $jLyQP.jsxs)("ul", {
                                                className: "mb-0",
                                                children: [
                                                    /*#__PURE__*/ (0, $jLyQP.jsx)("li", {
                                                        children: /*#__PURE__*/ (0, $jLyQP.jsxs)("a", {
                                                            href: `${$6b8304e8db19bdb3$export$7037112d28c7d171}/keys/${sampleAlg}.private.json`,
                                                            target: "_blank",
                                                            rel: "noreferrer",
                                                            children: [
                                                                $6b8304e8db19bdb3$export$7037112d28c7d171,
                                                                "/keys/",
                                                                sampleAlg,
                                                                ".private.json"
                                                            ]
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, $jLyQP.jsx)("li", {
                                                        children: /*#__PURE__*/ (0, $jLyQP.jsxs)("a", {
                                                            href: `${$6b8304e8db19bdb3$export$7037112d28c7d171}/keys/${sampleAlg}.private.pem`,
                                                            target: "_blank",
                                                            rel: "noreferrer",
                                                            children: [
                                                                $6b8304e8db19bdb3$export$7037112d28c7d171,
                                                                "/keys/",
                                                                sampleAlg,
                                                                ".private.pem"
                                                            ]
                                                        })
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $jLyQP.jsxs)("h5", {
                className: "text-primary",
                children: [
                    /*#__PURE__*/ (0, $jLyQP.jsx)("i", {
                        className: "bi bi-gear"
                    }),
                    " Advanced"
                ]
            }),
            /*#__PURE__*/ (0, $jLyQP.jsx)("div", {
                className: "my-2 bg-primary-subtle",
                style: {
                    height: 2
                }
            }),
            keyType !== "none" && /*#__PURE__*/ (0, $jLyQP.jsxs)("div", {
                className: "mb-4 mt-3 row",
                children: [
                    /*#__PURE__*/ (0, $jLyQP.jsxs)("div", {
                        className: "col",
                        children: [
                            /*#__PURE__*/ (0, $jLyQP.jsx)("label", {
                                htmlFor: "err",
                                className: "form-label text-primary-emphasis",
                                children: "Simulated Error"
                            }),
                            /*#__PURE__*/ (0, $jLyQP.jsxs)("select", {
                                className: "form-select",
                                value: err,
                                onChange: (e)=>dispatch({
                                        type: "setErr",
                                        payload: e.target.value
                                    }),
                                children: [
                                    /*#__PURE__*/ (0, $jLyQP.jsx)("option", {
                                        value: "",
                                        children: "None"
                                    }),
                                    /*#__PURE__*/ (0, $jLyQP.jsxs)("optgroup", {
                                        label: "During Authentication",
                                        children: [
                                            /*#__PURE__*/ (0, $jLyQP.jsx)("option", {
                                                value: "expired_registration_token",
                                                children: "Expired client"
                                            }),
                                            /*#__PURE__*/ (0, $jLyQP.jsx)("option", {
                                                value: "reg_invalid_scope",
                                                children: "Invalid scope"
                                            }),
                                            /*#__PURE__*/ (0, $jLyQP.jsx)("option", {
                                                value: "invalid_client",
                                                children: "Invalid client"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $jLyQP.jsxs)("optgroup", {
                                        label: "During Access",
                                        children: [
                                            /*#__PURE__*/ (0, $jLyQP.jsx)("option", {
                                                value: "invalid_scope",
                                                children: "Invalid scope"
                                            }),
                                            /*#__PURE__*/ (0, $jLyQP.jsx)("option", {
                                                value: "invalid_access_token",
                                                children: "Invalid access token"
                                            }),
                                            /*#__PURE__*/ (0, $jLyQP.jsx)("option", {
                                                value: "expired_access_token",
                                                children: "Expired access token"
                                            }),
                                            /*#__PURE__*/ (0, $jLyQP.jsx)("option", {
                                                value: "unauthorized_client",
                                                children: "Unauthorized client"
                                            }),
                                            /*#__PURE__*/ (0, $jLyQP.jsx)("option", {
                                                value: "too_many_patient_params",
                                                children: "Too many patient parameters at Kick-off request"
                                            }),
                                            /*#__PURE__*/ (0, $jLyQP.jsx)("option", {
                                                value: "too_frequent_status_requests",
                                                children: "Too frequent status requests"
                                            }),
                                            /*#__PURE__*/ (0, $jLyQP.jsx)("option", {
                                                value: "transient_status_error",
                                                children: "Job temporarily failing (transient error)"
                                            }),
                                            /*#__PURE__*/ (0, $jLyQP.jsx)("option", {
                                                value: "match_error",
                                                children: "Append match error to result bundles"
                                            }),
                                            /*#__PURE__*/ (0, $jLyQP.jsx)("option", {
                                                value: "file_not_found",
                                                children: "File not found during download"
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $jLyQP.jsx)("div", {
                                className: "form-text small",
                                children: "Force the server to throw certain type of error in different places (useful for manual testing)."
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $jLyQP.jsxs)("div", {
                        className: "col",
                        children: [
                            /*#__PURE__*/ (0, $jLyQP.jsx)("label", {
                                htmlFor: "dur",
                                className: "form-label text-primary-emphasis",
                                children: "Access Token Lifetime"
                            }),
                            /*#__PURE__*/ (0, $jLyQP.jsxs)("select", {
                                className: "form-select",
                                value: dur,
                                onChange: (e)=>dispatch({
                                        type: "setDur",
                                        payload: +e.target.value
                                    }),
                                children: [
                                    /*#__PURE__*/ (0, $jLyQP.jsx)("option", {
                                        value: 0,
                                        children: "Auto (whatever the client specified)"
                                    }),
                                    /*#__PURE__*/ (0, $jLyQP.jsx)("option", {
                                        value: 1,
                                        children: "1 minute"
                                    }),
                                    /*#__PURE__*/ (0, $jLyQP.jsx)("option", {
                                        value: 5,
                                        children: "5 minutes"
                                    }),
                                    /*#__PURE__*/ (0, $jLyQP.jsx)("option", {
                                        value: 15,
                                        children: "15 minutes"
                                    }),
                                    /*#__PURE__*/ (0, $jLyQP.jsx)("option", {
                                        value: 60,
                                        children: "1 hour"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $jLyQP.jsx)("div", {
                                className: "form-text small",
                                children: "Normally the client will determine how long should the access token be issued for, but this setting will take precedence if used."
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $jLyQP.jsx)("div", {
                className: "mb-2 mt-3 row",
                children: /*#__PURE__*/ (0, $jLyQP.jsxs)("div", {
                    className: "col",
                    children: [
                        /*#__PURE__*/ (0, $jLyQP.jsx)("label", {
                            className: "form-label text-primary-emphasis",
                            children: "Match Mode"
                        }),
                        /*#__PURE__*/ (0, $jLyQP.jsxs)("div", {
                            className: "btn-group w-100",
                            children: [
                                /*#__PURE__*/ (0, $jLyQP.jsx)("button", {
                                    type: "button",
                                    className: "btn" + (mode === "normal" ? " btn-primary bg-gradient active" : " border-secondary border-opacity-25"),
                                    onClick: ()=>dispatch({
                                            type: "setMode",
                                            payload: "normal"
                                        }),
                                    children: "Local Matches"
                                }),
                                /*#__PURE__*/ (0, $jLyQP.jsx)("button", {
                                    type: "button",
                                    className: "btn" + (mode === "fake" ? " btn-primary bg-gradient active" : " border-secondary border-opacity-25"),
                                    onClick: ()=>dispatch({
                                            type: "setMode",
                                            payload: "fake"
                                        }),
                                    children: "Simulated Matches"
                                }),
                                keyType !== "none" && /*#__PURE__*/ (0, $jLyQP.jsx)("button", {
                                    type: "button",
                                    className: "btn" + (mode === "remote" ? " btn-primary bg-gradient active" : " border-secondary border-opacity-25"),
                                    onClick: ()=>dispatch({
                                            type: "setMode",
                                            payload: "remote"
                                        }),
                                    children: "Proxy Matches"
                                })
                            ]
                        })
                    ]
                })
            }),
            mode === "normal" && /*#__PURE__*/ (0, $jLyQP.jsxs)("div", {
                className: "form-text small",
                children: [
                    "Match against patients in our ",
                    /*#__PURE__*/ (0, $jLyQP.jsxs)("a", {
                        href: $6b8304e8db19bdb3$export$7037112d28c7d171 + "/patients",
                        rel: "download",
                        children: [
                            "sample data set",
                            /*#__PURE__*/ (0, $jLyQP.jsx)("i", {
                                className: "bi bi-cloud-download ms-2"
                            })
                        ]
                    })
                ]
            }),
            mode === "fake" && /*#__PURE__*/ (0, $jLyQP.jsxs)((0, $jLyQP.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $jLyQP.jsx)("div", {
                        className: "form-text small",
                        children: 'The server will respond with "successful" matches for submitted patients even when they\'re not in our data set.'
                    }),
                    /*#__PURE__*/ (0, $jLyQP.jsxs)("div", {
                        className: "my-4 row",
                        children: [
                            /*#__PURE__*/ (0, $jLyQP.jsxs)("div", {
                                className: "col",
                                children: [
                                    /*#__PURE__*/ (0, $jLyQP.jsxs)("div", {
                                        className: "d-flex justify-content-between",
                                        children: [
                                            /*#__PURE__*/ (0, $jLyQP.jsx)("label", {
                                                htmlFor: "fakeMatches",
                                                className: "text-primary-emphasis",
                                                children: "Percentage of patients matched"
                                            }),
                                            /*#__PURE__*/ (0, $jLyQP.jsxs)("span", {
                                                children: [
                                                    fakeMatches,
                                                    "%"
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $jLyQP.jsx)("input", {
                                        type: "range",
                                        id: "fakeMatches",
                                        className: "form-range",
                                        value: fakeMatches,
                                        onChange: (e)=>dispatch({
                                                type: "setFakeMatches",
                                                payload: e.target.valueAsNumber
                                            }),
                                        min: 0,
                                        max: 100,
                                        step: 10
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $jLyQP.jsxs)("div", {
                                className: "col",
                                children: [
                                    /*#__PURE__*/ (0, $jLyQP.jsxs)("div", {
                                        className: "d-flex justify-content-between",
                                        children: [
                                            /*#__PURE__*/ (0, $jLyQP.jsx)("label", {
                                                htmlFor: "fakeDuplicates",
                                                className: "text-primary-emphasis",
                                                children: "Percentage with multiple matches"
                                            }),
                                            /*#__PURE__*/ (0, $jLyQP.jsxs)("span", {
                                                children: [
                                                    duplicates,
                                                    "%"
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $jLyQP.jsx)("input", {
                                        type: "range",
                                        id: "fakeDuplicates",
                                        className: "form-range d-block",
                                        value: duplicates,
                                        onChange: (e)=>dispatch({
                                                type: "setDuplicates",
                                                payload: e.target.valueAsNumber
                                            }),
                                        min: 0,
                                        max: 50,
                                        step: 5
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            mode === "remote" && /*#__PURE__*/ (0, $jLyQP.jsxs)((0, $jLyQP.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $jLyQP.jsxs)("div", {
                        className: "form-text small",
                        children: [
                            "The server will proxy the individual matches within the bulk request to a FHIR server that supports the ",
                            /*#__PURE__*/ (0, $jLyQP.jsx)("code", {
                                children: "Patient/$match"
                            }),
                            " operation."
                        ]
                    }),
                    /*#__PURE__*/ (0, $jLyQP.jsxs)("div", {
                        className: "my-4",
                        children: [
                            /*#__PURE__*/ (0, $jLyQP.jsx)("label", {
                                htmlFor: "err",
                                className: "form-label text-primary-emphasis",
                                children: "FHIR Server Base URL"
                            }),
                            /*#__PURE__*/ (0, $jLyQP.jsx)("input", {
                                type: "url",
                                className: "form-control",
                                value: matchServer,
                                onChange: (e)=>dispatch({
                                        type: "setMatchServer",
                                        payload: e.target.value
                                    }),
                                name: "url",
                                required: true
                            }),
                            /*#__PURE__*/ (0, $jLyQP.jsx)("div", {
                                className: "form-text small",
                                children: "The server will proxy the individual matches within the bulk request to this server"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $jLyQP.jsxs)("div", {
                        className: "my-4 row",
                        children: [
                            /*#__PURE__*/ (0, $jLyQP.jsxs)("div", {
                                className: "col",
                                children: [
                                    /*#__PURE__*/ (0, $jLyQP.jsx)("label", {
                                        className: "form-label text-primary-emphasis",
                                        children: "Client ID"
                                    }),
                                    /*#__PURE__*/ (0, $jLyQP.jsx)("input", {
                                        type: "text",
                                        className: "form-control",
                                        name: "proxy_client_id",
                                        value: proxyClientId,
                                        onChange: (e)=>dispatch({
                                                type: "setProxyClientId",
                                                payload: e.target.value
                                            })
                                    }),
                                    /*#__PURE__*/ (0, $jLyQP.jsx)("div", {
                                        className: "form-text small",
                                        children: "The Client ID you have registered for this server"
                                    }),
                                    /*#__PURE__*/ (0, $jLyQP.jsx)("label", {
                                        className: "mt-4 form-label text-primary-emphasis",
                                        children: "Scopes"
                                    }),
                                    /*#__PURE__*/ (0, $jLyQP.jsx)("input", {
                                        type: "text",
                                        className: "form-control",
                                        name: "proxy_scope",
                                        value: proxyScope,
                                        onChange: (e)=>dispatch({
                                                type: "setProxyScope",
                                                payload: e.target.value
                                            })
                                    }),
                                    /*#__PURE__*/ (0, $jLyQP.jsx)("div", {
                                        className: "form-text small",
                                        children: "Space-separated list of one or more scopes to request"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $jLyQP.jsxs)("div", {
                                className: "col",
                                children: [
                                    /*#__PURE__*/ (0, $jLyQP.jsx)("label", {
                                        className: "form-label text-primary-emphasis",
                                        children: "Private JWK"
                                    }),
                                    /*#__PURE__*/ (0, $jLyQP.jsx)("textarea", {
                                        className: "form-control",
                                        rows: 6,
                                        placeholder: "{ ...VALID JWK JSON... }",
                                        value: proxyJWK,
                                        onChange: (e)=>dispatch({
                                                type: "setProxyJWK",
                                                payload: e.target.value
                                            })
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $jLyQP.jsx)("div", {
                className: "my-4 mt-5 bg-primary-subtle",
                style: {
                    height: 2
                }
            }),
            keyType !== "none" && /*#__PURE__*/ (0, $jLyQP.jsx)("div", {
                className: "mb-3 text-center",
                children: /*#__PURE__*/ (0, $jLyQP.jsx)("button", {
                    type: "submit",
                    className: "btn btn-primary px-4 bg-gradient",
                    disabled: cannotSubmit,
                    children: "Register"
                })
            }),
            /*#__PURE__*/ (0, $jLyQP.jsx)("label", {
                className: "form-label text-primary-emphasis me-1",
                children: "Bulk Patient Matching Endpoint"
            }),
            /*#__PURE__*/ (0, $jLyQP.jsx)("div", {
                className: "mb-4 form-control bg-light form-control-sm",
                children: /*#__PURE__*/ (0, $jLyQP.jsx)("code", {
                    children: [
                        $6b8304e8db19bdb3$export$7037112d28c7d171,
                        mode === "fake" && fakeMatches > 0 ? fakeMatches + "-pct-matches" : "",
                        mode === "fake" && fakeMatches > 0 && !!duplicates ? duplicates + "-pct-duplicates" : "",
                        "fhir/Patient/$bulk-match"
                    ].filter(Boolean).join("/")
                })
            }),
            keyType !== "none" && !!assertion && /*#__PURE__*/ (0, $jLyQP.jsxs)((0, $jLyQP.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $jLyQP.jsxs)("div", {
                        className: "d-flex justify-content-between mb-1",
                        children: [
                            /*#__PURE__*/ (0, $jLyQP.jsx)("b", {
                                className: "text-primary-emphasis",
                                children: "Your Client ID:"
                            }),
                            /*#__PURE__*/ (0, $jLyQP.jsxs)("span", {
                                className: "copy-btn",
                                onClick: ()=>$6b8304e8db19bdb3$var$copy(assertion),
                                children: [
                                    "Copy ",
                                    /*#__PURE__*/ (0, $jLyQP.jsx)("i", {
                                        className: "bi bi-clipboard-check"
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $jLyQP.jsx)("textarea", {
                        className: "form-control text-primary-emphasis form-control-sm bg-light",
                        rows: 4,
                        value: assertion,
                        readOnly: true
                    })
                ]
            })
        ]
    });
}
async function $6b8304e8db19bdb3$var$copy(txt) {
    try {
        await navigator.clipboard.writeText(txt);
    } catch (err) {
        console.error('Failed to copy text to clipboard:', err);
        alert('Failed to copy text to clipboard.');
    }
}



var $jLyQP = parcelRequire("jLyQP");

var $gELpr = parcelRequire("gELpr");
const $968b8b3093428ca7$export$7037112d28c7d171 = (0, window.location.origin);
function $968b8b3093428ca7$var$NewTabLink({ href: href }) {
    return /*#__PURE__*/ (0, $jLyQP.jsxs)("a", {
        rel: "noopener noreferrer",
        target: "_blank",
        href: href,
        children: [
            href,
            /*#__PURE__*/ (0, $jLyQP.jsx)("i", {
                className: "bi bi-box-arrow-up-right ms-2"
            })
        ]
    });
}
function $968b8b3093428ca7$export$2e2bcd8739ae039() {
    const [config, setConfig] = (0, $gELpr.useState)({
        supportedAlgorithms: [
            "LOADING..."
        ],
        jobMaxLifetimeMinutes: 0,
        completedJobLifetimeMinutes: 0,
        resourceParameterLimit: 0
    });
    (0, $gELpr.useEffect)(()=>{
        fetch($968b8b3093428ca7$export$7037112d28c7d171 + "/config").then((res)=>res.json()).then(setConfig);
    }, []);
    return /*#__PURE__*/ (0, $jLyQP.jsxs)("div", {
        className: "py-4",
        children: [
            /*#__PURE__*/ (0, $jLyQP.jsx)("h2", {
                children: "Server Information"
            }),
            /*#__PURE__*/ (0, $jLyQP.jsx)("hr", {
                className: "mt-1"
            }),
            /*#__PURE__*/ (0, $jLyQP.jsxs)("dl", {
                children: [
                    /*#__PURE__*/ (0, $jLyQP.jsxs)("dt", {
                        children: [
                            /*#__PURE__*/ (0, $jLyQP.jsx)("i", {
                                className: "bi bi-arrow-right-circle-fill text-success me-2"
                            }),
                            "Bulk Patient Matching Endpoint"
                        ]
                    }),
                    /*#__PURE__*/ (0, $jLyQP.jsxs)("dd", {
                        className: "mb-4",
                        children: [
                            /*#__PURE__*/ (0, $jLyQP.jsxs)("code", {
                                children: [
                                    $968b8b3093428ca7$export$7037112d28c7d171,
                                    "/fhir/Patient/$bulk-match"
                                ]
                            }),
                            /*#__PURE__*/ (0, $jLyQP.jsxs)("div", {
                                className: "small text-secondary",
                                children: [
                                    "Use this to match your patients as described in the IG at ",
                                    /*#__PURE__*/ (0, $jLyQP.jsx)($968b8b3093428ca7$var$NewTabLink, {
                                        href: "https://build.fhir.org/ig/HL7/bulk-data/branches/bulk-match/match.html"
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $jLyQP.jsxs)("dt", {
                        children: [
                            /*#__PURE__*/ (0, $jLyQP.jsx)("i", {
                                className: "bi bi-arrow-right-circle-fill text-success me-2"
                            }),
                            "Token Endpoint"
                        ]
                    }),
                    /*#__PURE__*/ (0, $jLyQP.jsxs)("dd", {
                        className: "mb-4",
                        children: [
                            /*#__PURE__*/ (0, $jLyQP.jsxs)("code", {
                                children: [
                                    $968b8b3093428ca7$export$7037112d28c7d171,
                                    "/auth/token"
                                ]
                            }),
                            /*#__PURE__*/ (0, $jLyQP.jsxs)("div", {
                                className: "small text-secondary",
                                children: [
                                    "Send your authentication request here, as described in the Backend Services IG at ",
                                    /*#__PURE__*/ (0, $jLyQP.jsx)($968b8b3093428ca7$var$NewTabLink, {
                                        href: "https://www.hl7.org/fhir/smart-app-launch/backend-services.html"
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $jLyQP.jsxs)("dt", {
                        children: [
                            /*#__PURE__*/ (0, $jLyQP.jsx)("i", {
                                className: "bi bi-arrow-right-circle-fill text-success me-2"
                            }),
                            "Well-Known SMART Configuration"
                        ]
                    }),
                    /*#__PURE__*/ (0, $jLyQP.jsxs)("dd", {
                        className: "mb-4",
                        children: [
                            /*#__PURE__*/ (0, $jLyQP.jsx)("code", {
                                children: /*#__PURE__*/ (0, $jLyQP.jsx)($968b8b3093428ca7$var$NewTabLink, {
                                    href: $968b8b3093428ca7$export$7037112d28c7d171 + "/fhir/.well-known/smart-configuration"
                                })
                            }),
                            /*#__PURE__*/ (0, $jLyQP.jsx)("div", {
                                className: "small text-secondary"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $jLyQP.jsxs)("dt", {
                        children: [
                            /*#__PURE__*/ (0, $jLyQP.jsx)("i", {
                                className: "bi bi-arrow-right-circle-fill text-success me-2"
                            }),
                            "Authentication Keys"
                        ]
                    }),
                    /*#__PURE__*/ (0, $jLyQP.jsxs)("dd", {
                        className: "mb-4",
                        children: [
                            /*#__PURE__*/ (0, $jLyQP.jsx)("code", {
                                children: /*#__PURE__*/ (0, $jLyQP.jsx)($968b8b3093428ca7$var$NewTabLink, {
                                    href: $968b8b3093428ca7$export$7037112d28c7d171 + "/keys"
                                })
                            }),
                            /*#__PURE__*/ (0, $jLyQP.jsx)("div", {
                                className: "small text-secondary",
                                children: "Since this is a reference implementation server and there is no API for any data mutations, we publish our keys, including the private ones. This is ONLY done to simplify the process of connecting and testing!"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $jLyQP.jsxs)("dt", {
                        children: [
                            /*#__PURE__*/ (0, $jLyQP.jsx)("i", {
                                className: "bi bi-arrow-right-circle-fill text-success me-2"
                            }),
                            "Supported Signing Algorithms"
                        ]
                    }),
                    /*#__PURE__*/ (0, $jLyQP.jsxs)("dd", {
                        className: "mb-4",
                        children: [
                            config.supportedAlgorithms.map((alg, i, all)=>{
                                if (i === all.length - 1) return /*#__PURE__*/ (0, $jLyQP.jsx)("code", {
                                    children: alg
                                }, i);
                                return /*#__PURE__*/ (0, $jLyQP.jsxs)("span", {
                                    children: [
                                        /*#__PURE__*/ (0, $jLyQP.jsx)("code", {
                                            children: alg
                                        }),
                                        ", "
                                    ]
                                }, i);
                            }),
                            /*#__PURE__*/ (0, $jLyQP.jsx)("div", {
                                className: "small text-secondary",
                                children: "You can sign your client_assertion with private keys using any of these algorithms and the server should be able to verify them using the corresponding public key."
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $jLyQP.jsxs)("dt", {
                        children: [
                            /*#__PURE__*/ (0, $jLyQP.jsx)("i", {
                                className: "bi bi-arrow-right-circle-fill text-success me-2"
                            }),
                            "Available Patients"
                        ]
                    }),
                    /*#__PURE__*/ (0, $jLyQP.jsxs)("dd", {
                        className: "mb-4",
                        children: [
                            /*#__PURE__*/ (0, $jLyQP.jsx)("code", {
                                children: /*#__PURE__*/ (0, $jLyQP.jsxs)("a", {
                                    href: $968b8b3093428ca7$export$7037112d28c7d171 + "/patients",
                                    children: [
                                        $968b8b3093428ca7$export$7037112d28c7d171,
                                        "/patients",
                                        /*#__PURE__*/ (0, $jLyQP.jsx)("i", {
                                            className: "bi bi-cloud-download ms-2"
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0, $jLyQP.jsx)("div", {
                                className: "small text-secondary",
                                children: "Patients on the server that can be matched"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $jLyQP.jsxs)("dt", {
                        children: [
                            /*#__PURE__*/ (0, $jLyQP.jsx)("i", {
                                className: "bi bi-arrow-right-circle-fill text-success me-2"
                            }),
                            "Completed Jobs are Deleted After"
                        ]
                    }),
                    /*#__PURE__*/ (0, $jLyQP.jsxs)("dd", {
                        className: "mb-4",
                        children: [
                            /*#__PURE__*/ (0, $jLyQP.jsxs)("code", {
                                children: [
                                    config.completedJobLifetimeMinutes,
                                    " minutes"
                                ]
                            }),
                            /*#__PURE__*/ (0, $jLyQP.jsxs)("div", {
                                className: "small text-secondary",
                                children: [
                                    "Once a match job is completed a client has ",
                                    config.completedJobLifetimeMinutes,
                                    " minutes to download the results before they are deleted."
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $jLyQP.jsxs)("dt", {
                        children: [
                            /*#__PURE__*/ (0, $jLyQP.jsx)("i", {
                                className: "bi bi-arrow-right-circle-fill text-success me-2"
                            }),
                            "Pending Jobs are Deleted After"
                        ]
                    }),
                    /*#__PURE__*/ (0, $jLyQP.jsxs)("dd", {
                        className: "mb-4",
                        children: [
                            /*#__PURE__*/ (0, $jLyQP.jsxs)("code", {
                                children: [
                                    config.jobMaxLifetimeMinutes,
                                    " minutes"
                                ]
                            }),
                            /*#__PURE__*/ (0, $jLyQP.jsxs)("div", {
                                className: "small text-secondary",
                                children: [
                                    "If for whatever reason a match job is unable to complete in ",
                                    config.jobMaxLifetimeMinutes,
                                    " minutes, the server will delete it regardless of its current status."
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $jLyQP.jsxs)("dt", {
                        children: [
                            /*#__PURE__*/ (0, $jLyQP.jsx)("i", {
                                className: "bi bi-arrow-right-circle-fill text-success me-2"
                            }),
                            "Max Patient Parameters"
                        ]
                    }),
                    /*#__PURE__*/ (0, $jLyQP.jsxs)("dd", {
                        className: "mb-4",
                        children: [
                            /*#__PURE__*/ (0, $jLyQP.jsx)("code", {
                                children: config.resourceParameterLimit
                            }),
                            /*#__PURE__*/ (0, $jLyQP.jsx)("div", {
                                className: "small text-secondary",
                                children: "A client may not send more then this number of patient parameters in one match request. If If a client needs to match more you will have to split them into multiple match requests."
                            })
                        ]
                    })
                ]
            })
        ]
    });
}



var $b42dae0de6b0d255$exports = {};
$b42dae0de6b0d255$exports = import.meta.resolve("jROdh");


function $dc0e72fba15776af$export$2e2bcd8739ae039() {
    const [tabIndex, setTabIndex] = (0, $gELpr.useState)(1);
    const [env, setEnv] = (0, $gELpr.useState)({});
    const BACKEND_BASE_URL = (0, window.location.origin);
    (0, $gELpr.useEffect)(()=>{
        fetch(BACKEND_BASE_URL + "/env").then((res)=>res.json()).then(setEnv).catch(console.error);
    }, []);
    return /*#__PURE__*/ (0, $jLyQP.jsxs)((0, $jLyQP.Fragment), {
        children: [
            /*#__PURE__*/ (0, $jLyQP.jsx)("nav", {
                className: "navbar sticky-top navbar-expand-lg bg-primary-subtle bg-gradient",
                children: /*#__PURE__*/ (0, $jLyQP.jsxs)("div", {
                    className: "container",
                    children: [
                        /*#__PURE__*/ (0, $jLyQP.jsx)("h1", {
                            className: "navbar-brand m-0",
                            children: /*#__PURE__*/ (0, $jLyQP.jsxs)("a", {
                                className: "navbar-brand text-primary-emphasis",
                                href: "/",
                                style: {
                                    textShadow: "0 1px 1px #FFF"
                                },
                                children: [
                                    /*#__PURE__*/ (0, $jLyQP.jsx)("img", {
                                        src: (0, (/*@__PURE__*/$parcel$interopDefault($b42dae0de6b0d255$exports))),
                                        width: "66",
                                        style: {
                                            margin: "-20px 6px -20px 0"
                                        }
                                    }),
                                    "Bulk Match Provider"
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, $jLyQP.jsx)("button", {
                            className: "navbar-toggler",
                            type: "button",
                            "data-bs-toggle": "collapse",
                            "data-bs-target": "#navbarSupportedContent",
                            "aria-controls": "navbarSupportedContent",
                            "aria-expanded": "false",
                            "aria-label": "Toggle navigation",
                            children: /*#__PURE__*/ (0, $jLyQP.jsx)("span", {
                                className: "navbar-toggler-icon"
                            })
                        }),
                        /*#__PURE__*/ (0, $jLyQP.jsxs)("div", {
                            className: "collapse navbar-collapse",
                            id: "navbarSupportedContent",
                            children: [
                                /*#__PURE__*/ (0, $jLyQP.jsx)("ul", {
                                    className: "navbar-nav me-auto"
                                }),
                                /*#__PURE__*/ (0, $jLyQP.jsxs)("ul", {
                                    className: "nav nav-pills",
                                    children: [
                                        /*#__PURE__*/ (0, $jLyQP.jsx)("li", {
                                            className: "nav-item",
                                            children: /*#__PURE__*/ (0, $jLyQP.jsx)("a", {
                                                className: "nav-link" + (tabIndex === 1 ? " active bg-gradient" : ""),
                                                onClick: (e)=>{
                                                    e.preventDefault();
                                                    setTabIndex(1);
                                                },
                                                href: "#",
                                                children: "Client Registration"
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $jLyQP.jsx)("li", {
                                            className: "nav-item",
                                            children: /*#__PURE__*/ (0, $jLyQP.jsx)("a", {
                                                className: "nav-link" + (tabIndex === 0 ? " active bg-gradient" : ""),
                                                onClick: (e)=>{
                                                    e.preventDefault();
                                                    setTabIndex(0);
                                                },
                                                href: "#",
                                                children: "Server Info"
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $jLyQP.jsx)("li", {
                                            className: "nav-item",
                                            children: /*#__PURE__*/ (0, $jLyQP.jsx)("a", {
                                                className: "nav-link",
                                                href: "/sample-app",
                                                target: "_blank",
                                                children: /*#__PURE__*/ (0, $jLyQP.jsxs)("b", {
                                                    children: [
                                                        "Sample App",
                                                        /*#__PURE__*/ (0, $jLyQP.jsx)("i", {
                                                            className: "bi bi-box-arrow-up-right ms-2"
                                                        })
                                                    ]
                                                })
                                            })
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $jLyQP.jsx)("div", {
                className: "container my-3",
                children: /*#__PURE__*/ (0, $jLyQP.jsxs)("div", {
                    className: "tab-content",
                    children: [
                        /*#__PURE__*/ (0, $jLyQP.jsx)("div", {
                            className: "tab-pane" + (tabIndex === 0 ? " show active" : ""),
                            role: "tabpanel",
                            tabIndex: 0,
                            children: /*#__PURE__*/ (0, $jLyQP.jsx)((0, $968b8b3093428ca7$export$2e2bcd8739ae039), {})
                        }),
                        /*#__PURE__*/ (0, $jLyQP.jsx)("div", {
                            className: "tab-pane" + (tabIndex === 1 ? " show active" : ""),
                            role: "tabpanel",
                            tabIndex: 0,
                            children: /*#__PURE__*/ (0, $jLyQP.jsx)((0, $6b8304e8db19bdb3$export$2e2bcd8739ae039), {})
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $jLyQP.jsxs)("div", {
                className: "bg-light border border-top py-4",
                children: [
                    /*#__PURE__*/ (0, $jLyQP.jsxs)("div", {
                        className: "text-center small mb-2",
                        children: [
                            "Submit an issue or PR on ",
                            /*#__PURE__*/ (0, $jLyQP.jsx)("a", {
                                href: "https://github.com/smart-on-fhir/bulk-match-provider",
                                rel: "noreferrer noopener",
                                target: "_blank",
                                children: "GitHub"
                            }),
                            "."
                        ]
                    }),
                    /*#__PURE__*/ (0, $jLyQP.jsxs)("div", {
                        className: "text-center small",
                        children: [
                            /*#__PURE__*/ (0, $jLyQP.jsx)("b", {
                                children: " Version:"
                            }),
                            " ",
                            env.VERSION
                        ]
                    })
                ]
            })
        ]
    });
}


(0, $2qSCu.createRoot)(document.getElementById("app")).render(/*#__PURE__*/ (0, $jLyQP.jsx)((0, $dc0e72fba15776af$export$2e2bcd8739ae039), {}));


//# sourceMappingURL=app.45e791f0.js.map
